module.exports = __webpack_public_path__ + "static/help-img-2-0b4657612829bde59c5498da13c388e4.svg";